import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { DialogConfig } from '../../dialog-config';
import { DialogRef } from '../../dialog-ref';

export interface PopupPromptDialogConfig {
  title: string;
  body?: string;
  bodyData?: Record<string, string>;
  primaryButtonLabel: string;
  primaryButtonClick?: () => void;
  secondaryButtonLabel: string;
  secondaryButtonClick?: () => void;
  showCloseButton?: boolean;
}

@Component({
  selector: 'rd-popup-prompt-dialog',
  templateUrl: './prompt-dialog.component.html',
  styleUrls: ['./prompt-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopupPromptDialogComponent {
  @HostBinding('class.rd-popup-prompt-dialog') componentClass = true;

  dialogData?: PopupPromptDialogConfig = this.dialogConfig.data;

  constructor(
    private dialogRef: DialogRef,
    private dialogConfig: DialogConfig<PopupPromptDialogConfig>,
  ) {}

  primaryClick(): void {
    if (this.dialogData?.primaryButtonClick) {
      this.dialogData.primaryButtonClick();
    }
    this.dialogRef.close();
  }

  secondaryClick(): void {
    if (this.dialogData?.secondaryButtonClick) {
      this.dialogData.secondaryButtonClick();
    }
    this.dialogRef.close();
  }
}
